import useControlledBrowseQueryParams from "../../utils/useControlledBrowseQueryParams"

const isLibraryRootPath = (pathname: string) =>
  pathname === "/library/" || pathname === "/library"

/** Library browse: syncs `?category=` / `?author=` / `?search=` with facet state. */
const useControlledLibraryQueryParams = () =>
  useControlledBrowseQueryParams({ isRootPath: isLibraryRootPath })

export default useControlledLibraryQueryParams
